import cx from 'classnames';
import React from 'react';

import PartLazyImage from '../../part-lazy-image';

import IconCheckmarkBig from './assets/icon-checkmark-big.svg';
import ImageZeroPressure from './assets/image-zero-pressure.webp';

import styles from './part-estimation-form.module.scss';

export default function PartEstimationForm() {
  return (
    <div className={styles.formBox}>
      <form className={styles.form}>

        <div className={cx(styles.stepContainer, styles.stepContainer_current, styles.step1)}>
         <div className={styles.step4__iconDone}>
            <IconCheckmarkBig />
          </div>
          <p className={styles.step4__title}>Thank you for your request!</p>

          <p className={styles.step4__paragpaph}>
            One of our team members will contact you shortly to schedule
            <br className="visibleOnDesktopAndTablet" />
            {' '}
            your Free Estimate.
          </p>
        </div>

        <div className={styles.step1__imageZeroPressure}>
          <PartLazyImage
            src={ImageZeroPressure}
            alt="pass the test to get a discount"
          />
        </div>
      </form>
    </div>
  );
}
